'use strict';

/* prefers-reduced-motion: 視差効果を減らす設定。ローダーの分岐に使う（下記） */
const stillReduceMotion = window.matchMedia
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* Loader tagline: hand-writing character-by-character reveal
   2026-08-05: 空白を半角スペースから NBSP( ) に変更。
   display:inline-block の span に入れた半角スペースは innerText から消えるため、
   H1・タグラインの取得テキストが "wheretheheartfindsrest." になっていた（検索エンジンと
   支援技術が読む側が壊れる）。幅は .loader__char--space { width:0.32em } が決めているので
   NBSP にしても見た目は変わらない。同じ修正を FV の split() 側にも入れている。 */
(function() {
  const el = document.querySelector('.loader__tagline');
  if (!el) return;
  const chars = [...el.textContent];
  el.textContent = '';
  chars.forEach((ch, i) => {
    const span = document.createElement('span');
    const isSp = ch === ' ';
    span.className = 'loader__char' + (isSp ? ' loader__char--space' : '');
    span.textContent = isSp ? ' ' : ch;
    span.style.animationDelay = (720 + i * 32) + 'ms';
    el.appendChild(span);
  });
})();

/* Loader: コンテンツ準備（DOM＋フォント＋最小演出）で消す。
   重い動画など全リソース完了(window.load)は待たない＝根本的に速く消える

   2026-08-05: reduced-motion 時は掴まない。
   CSS 側は @media (prefers-reduced-motion:reduce) で .loader を display:none にしているが、
   要素は DOM に残るため、この分岐が無いと「ローダーは見えないのに
   body の overflow だけ 3.5 秒以上ロックされる」状態になっていた。 */
const loader = stillReduceMotion ? null : document.querySelector('#loader');
if (loader) {
  /* ⚠️ 2026-08-13: `body{overflow:hidden}` をやめた。**iOS では効かない**ため、
     ローダー表示中にスクロールでき、URLバーが縮んで下端に帯が出ていた（QA #62）。
     ロックは theme.liquid のインライン script が読み込み時点で掛けている（defer より早い）。
     ここは**解除だけ**を担当する。実体は window.stillScrollLock（body{position:fixed}）。 */
  const unlockScroll = () => { if (window.stillScrollLock) window.stillScrollLock.unlock(); };

  /*
    ⚠️ **解除の時刻を数値で書かないこと（2026-08-14 実害・Tomoya 実機検出）。**

    ここには長らく `setTimeout(unlockScroll, 900)` が固定値で書かれていた。
    当時のフェードがちょうど 900ms だったので、**解除とベールの消滅が同時**になり、
    解除にともなう見た目の変化がベールに隠れていた。

    2026-08-14 にフェードを 1700ms へ延ばしたとき、**この 900 を直し忘れた。**
    結果、**ベールがまだ残っている（実測 opacity 0.16）状態で解除が走る**ようになり、
    隠れていたはずの変化が露出した。実測（iPhone エミュレーション・ライブ）:

    | 経過 | ベール | body fixed | documentElement の高さ |
    |---|---|---|---|
    | 3300ms（フェード開始） | 0.96 | true | 1159px |
    | **4050ms（＝開始+900）** | **0.16** | **false** | **auto（docH 1159 → 4967）** |
    | 4800ms（フェード終了） | 0.00 | false | auto |

    解除の瞬間に**文書の高さが 1159 → 4967 へ跳ねる**。2026-08-13 の調査どおり、
    iOS はこれを見て URLバーの扱いを変えるため、**FV 下端の波がそこで一気に現れる**
    （Tomoya「白い帯が出て、波が隠れていて、そのあとパッて出てくる」）。
    ⚠️ **波は URLバーが座る帯（実測 760..808px）にある**ので、この変化が最も見える場所。

    → **CSS から実際の再生時間を読む。**これで CSS を変えても JS が自動で追従し、
      同じズレが二度と起きない。数値を2箇所で持たない。
  */
  function veilDurationMs() {
    const toMs = (v) => (v || '').split(',')
      .map((s) => {
        s = s.trim();
        const n = parseFloat(s);
        return isNaN(n) ? 0 : (s.endsWith('ms') ? n : n * 1000);
      })
      .filter((n) => n > 0);
    /* .gone を付けたあとに読むこと（animation は .loader.gone 側で宣言している） */
    const cs = getComputedStyle(loader);
    const all = toMs(cs.animationDuration).concat(toMs(cs.transitionDuration));
    /* 読めなかったときだけのフォールバック。**ここを「正しい値」にしない** —
       CSS と一致させる責任を持たせると、また2箇所管理に戻る */
    return all.length ? Math.max.apply(null, all) : 2000;
  }

  let dismissed = false;
  function hideLoader() {
    if (dismissed) return;
    dismissed = true;
    loader.classList.add('gone');

    /*
      🚫🚫 **解除の時刻をこれ以上いじらないこと（2026-08-14・5巡して確定）。** 🚫🚫

      解除は「**ローダーが完全に消えきったとき**」で固定する。**前倒ししない。**

      ロックが守っているのは**スクロールだけではない**。ロックを外すとスクロールできてしまい、
      **デバイスの上端・下端に背景（キャンバス）が見える**——これは 2026-08-13 に
      塗り足し（`top:-240 / height:innerHeight+480`）と併せて対処した**当初からの論点**。
      **ローダーが見えている間はロックが要る。フェード中も「見えている間」に含まれる。**

      5巡の記録（すべて Tomoya 実機で判定）:
      | 巡 | 変更 | 結果 |
      |---|---|---|
      | 1 | 解除を尺の終わりへ（＝いまここ） | 帯の変化は残る（が、守りは崩れない） |
      | 2 | 解除をフェード開始へ | **フェード中1.7秒ぶん守りが外れる** |
      | 3 | + 高さの跳ねを消す | 同上。帯は静まるがバーの遷移は残る |
      | 4 | 解除を DOM 直後へ | **ローダーが下端を覆えず写真が露出** |
      | 5 | ロックを一切掛けない | **同じく下端に写真が露出**。却下 |

      **残る帯の変化は、ページ側では消せない**（URLバーはブラウザのUIで、覆えない・時刻も読めない）。
      **消せないものを消そうとして守りを削る、を4回繰り返した。**帯は受け入れる。

      ⚠️ `animationend` は子（.loader__center の veilMarkSoft・.loader__char）からも
         バブリングしてくる。**必ず target を見て絞る。**
         `{once:true}` を使わないのはそのため（子のイベントで解除されて本命を取り逃がす）
    */
    const onEnd = (e) => {
      if (e.target !== loader) return;
      loader.removeEventListener('animationend', onEnd);
      unlockScroll();
    };
    loader.addEventListener('animationend', onEnd);

    /* 不発時の保険。`unlock()` は二重呼び出しを自前で弾く（theme.liquid の depth ガード） */
    setTimeout(unlockScroll, veilDurationMs() + 120);
  }
  const fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  const domReady = (document.readyState !== 'loading')
    ? Promise.resolve()
    : new Promise(r => document.addEventListener('DOMContentLoaded', r, { once: true }));
  // タグライン手書きアニメは "where the heart finds rest." 27文字で
  // 720ms + 26*32ms + 200ms = ~1752ms かかる。完了後に余韻を残してから消す。
  const minDisplay = new Promise(r => setTimeout(r, 2800));
  Promise.all([domReady, fontsReady, minDisplay])
    .then(() => requestAnimationFrame(() => requestAnimationFrame(hideLoader)));
  // 安全網（通常は発火しない）: フォント解決が来ない低速環境でも必ず消す
  setTimeout(hideLoader, 6500);
}

// /* FV wave fade-in: independent of loader so it works on all pages */
// (function() {
//   const fv = document.querySelector('.fv');
//   if (!fv) return;
//   function ready() {
//     requestAnimationFrame(() => requestAnimationFrame(() => {
//       fv.classList.add('fv--wave-ready');
//     }));
//   }
//   if (document.readyState === 'complete') ready();
//   else window.addEventListener('load', ready, { once: true });
// })();



/* Header on scroll (theme-color は HTML の meta タグで静的固定) */
const hdr = document.querySelector('.hdr');
if (hdr) {
  const hasFVHero = !!document.getElementById('hero');
  function syncHeader() {
    const scrolled = window.scrollY > 20;
    hdr.classList.toggle('on', !hasFVHero || scrolled);
  }
  window.addEventListener('scroll', syncHeader, { passive: true });
  syncHeader();
}

/* Scroll reveal */
const isMobile = window.innerWidth <= 768;
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('on');
      e.target.addEventListener('transitionend', () => { e.target.style.willChange = 'auto'; }, { once: true });
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: isMobile ? 0.04 : 0.1, rootMargin: isMobile ? '0px 0px 80px 0px' : '0px 0px -20px 0px' });
document.querySelectorAll('[data-r]').forEach(el => revealObs.observe(el));

/* Floating button: show after hero leaves viewport */
const fab  = document.querySelector('.fab');
const hero = document.querySelector('#hero');
if (fab && hero) {
  const fabObs = new IntersectionObserver(([e]) => {
    fab.classList.toggle('on', !e.isIntersecting);
  }, { threshold: 0.1 });
  fabObs.observe(hero);
}

/* Hero content: fade + lift on scroll (desktop only — mobile skips to avoid layout shift) */
const heroInner = document.querySelector('#hero .fv__inner, #hero .hero__inner');
if (heroInner && window.innerWidth > 768) {
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY, h = window.innerHeight;
      if (y < h) {
        heroInner.style.opacity   = String(Math.max(0, 1 - y / (h * 0.5)));
        heroInner.style.transform = `translateY(${y * 0.08}px)`;
      }
      ticking = false;
    });
  }, { passive: true });
}

/* Mobile drawer menu */
const menuToggle   = document.querySelector('#menuToggle');
const drawer       = document.querySelector('#drawer');
const drawerOverlay= document.querySelector('#drawerOverlay');
const drawerClose  = document.querySelector('#drawerClose');
/*
  2026-10-08: メニューを開いている間は **文書を完全にスクロール不能にする**。

  Tomoya「URLバー部分の背景色の、バーの伸縮に対応した変動がかくついてる」。
  `stillScrollLock` は body を fixed にしたうえで **html に元の高さを入れて
  「スクロールできるページ」をわざと保つ**（theme.liquid:595）。
  そのため **メニューを開いたままでも指でスクロールでき、iOS は URLバーを伸縮させる。**
  バーが動くたびに下端まわりの色が変わり、それがカクつきとして見えていた。
  ＝ 色を直す問題ではなく、**バーを動かさない**のが筋。

  ⚠️ theme.liquid:595 は `🚫 html{overflow:hidden} を足すな` としているが、
     **その禁止が置かれた前提はもう無い。**
     当時の理由は「スクロール不能にすると iOS がバーを開いた状態に戻し、
     表示領域が約40px 縮んで **fixed 要素（当時 height:100svh）が描けない帯**が下端に出る」。
     いまは `.drawer` が `height:100lvh`・`.drawer__overlay` が `150lvh` で、
     **取り得る最大の表示領域より大きい**ため、40px 縮んでも露出する帯が存在しない。
  ⚠️ カートドロワー（.cd）には適用しない。あちらは `bottom:0` で実ビューポートに追従する作りで、
     バーが開いた状態に固定されると「レジに進む」の見え方が変わる。実機で解決済みなので触らない。
  ⚠️ 解除は **unlock() より先**に行う。unlock() が scrollTo で位置を戻すため、
     先に overflow を戻しておかないとスクロールできず位置が復元されない。
*/
/*
  ⚠️ **タッチ端末に限定する。** `html{overflow:hidden}` はスクロールバーの溝も畳むため、
     クラシックなスクロールバーを持つ環境（Windows 等）では **コンテンツが約15px 右へずれる**。
     2026-10-07 にカートで同じ事故を起こしている（原因は当時 `scrollbar-gutter:auto`）。
     モバイルはオーバーレイスクロールバーで溝を取らないので、ずれは起きない。
     そもそも `.hdr__menu`（メニューを開くボタン）は 768px 以下でしか出ない。
*/
function hardLockApplies() {
  return window.matchMedia('(pointer: coarse)').matches;
}
function openDrawer() {
  if (!drawer) return;
  drawer.classList.add('on');
  drawerOverlay.classList.add('on');
  menuToggle?.setAttribute('aria-expanded', 'true');
  /* ⚠️ `body{overflow:hidden}` から変更（2026-08-13・QA #62）。**iOS では効かず**、
     メニューを開いたままスクロールできてしまい、URLバーが縮んで
     **fixed 要素が描けない帯**が下端に出ていた。モーダルは本来スクロールを止めるべきもの。 */
  if (window.stillScrollLock) window.stillScrollLock.lock();
  if (hardLockApplies()) document.documentElement.style.overflow = 'hidden';
}
function closeDrawer() {
  if (!drawer) return;
  drawer.classList.remove('on');
  drawerOverlay.classList.remove('on');
  menuToggle?.setAttribute('aria-expanded', 'false');
  document.documentElement.style.overflow = '';
  if (window.stillScrollLock) window.stillScrollLock.unlock();
}
menuToggle?.addEventListener('click', openDrawer);
drawerClose?.addEventListener('click', closeDrawer);
drawerOverlay?.addEventListener('click', closeDrawer);
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

/* FV character split typography animation */
(function() {
  const jp   = document.querySelector('.fv__brand-jp');
  const en   = document.querySelector('.fv__tagline');
  const acts = document.querySelector('.fv__actions');
  const fv   = document.getElementById('hero');
  if (!en || !fv) return;

  function split(el, gapMs, offsetMs) {
    const chars = [...el.textContent];
    // 分解前の原文を aria-label に退避する（分解後は読み上げ・検索エンジン用の
    // テキストが1語に潰れるため）。2026-08-05
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.textContent.trim());
    el.textContent = '';
    chars.forEach((ch, i) => {
      const span = document.createElement('span');
      const isSp = /[ 　]/.test(ch);
      span.className = 'fv__char' + (isSp ? ' fv__char--space' : '');
      // NBSP。半角スペースだと innerText から消える（上のローダー側と同じ理由）
      span.textContent = isSp ? ' ' : ch;
      span.style.animationDelay = (offsetMs + i * gapMs) + 'ms';
      el.appendChild(span);
    });
    return chars.length;
  }

  let off = 0;
  if (jp) { const n = split(jp, 55, off); off += n * 55 + 320; }
  const enLen = [...en.textContent].length;
  split(en, 38, off);
  off += enLen * 38 + 500;
  if (acts) acts.style.animationDelay = off + 'ms';

  setTimeout(() => fv.classList.add('fv--ready'), 1900);
})();

/* SVG line draw on scroll (stroke-dashoffset technique) */
const drawObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.querySelectorAll('.draw-path').forEach((path, i) => {
      const len = path.getTotalLength();
      path.style.strokeDasharray = len;
      path.style.strokeDashoffset = len;
      path.style.transition = `stroke-dashoffset ${2.0 + i * 0.5}s cubic-bezier(0.4,0,0.2,1) ${i * 0.4}s`;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        path.style.strokeDashoffset = '0';
      }));
    });
    drawObs.unobserve(e.target);
  });
}, { threshold: 0.15 });
document.querySelectorAll('.deco-svg').forEach(el => drawObs.observe(el));

/* FV video: reveal only after first frame is painted (avoids square flash on iOS Safari)
   2026-08-04 修正: 「再生できたときだけ」出すように条件を締めた。

   旧実装は loadeddata / readyState / 3秒タイマーでも reveal しており、
   autoplay が拒否されて video が paused のままでも opacity:1 になっていた。
   iOS Safari は再生されていない video に**ネイティブの再生ボタン**を重ねて描くため、
   FV 中央に ▶ が出てタグラインに被る（2026-08-04 実機で確認）。

   autoplay が拒否される主因は iOS の低電力モード。
   この状態では muted+playsinline でもブラウザ側が一律で止めるため、コードでは回避できない。

   したがって「再生できなければ video を出さない」を正とする。
   video が opacity:0 のままなら下の <img class="fv__poster"> がそのまま見え、
   静止画のヒーローとして成立する（▶ は出ない）。
   タップで再生に成功すれば playing が発火して通常どおり出る。 */
(function() {
  const v = document.querySelector('.fv__media');
  if (!v) return;
  function reveal() { v.classList.add('is-playing'); }
  // 実際に再生が始まった唯一の確実な合図
  v.addEventListener('playing', reveal, { once: true });
  // playing が取りこぼされた場合の保険。paused のままなら出さない
  setTimeout(function () {
    if (!v.paused && v.currentTime > 0) reveal();
  }, 3000);
})();

/* FV video: src を JS で後から入れる（2026-08-05）

   旧: HTML の autoplay 属性まかせ。autoplay は「メタデータだけ」では済まず本体を取りに行くので、
       14.85MB の動画がタグライン表示と帯域を奪い合っていた。
   新: markup は preload="none" / src なし。window.load 後のアイドル時に
       画面幅で 960 / 1280 を選んで入れる。ポスター（AVIF）は先に出ているので見た目は変わらない。

   出さない条件（どちらもポスター静止画のまま成立する）:
     - prefers-reduced-motion: reduce
     - データセーバー / 2G 相当（Network Information API がある環境のみ判定できる） */
(function() {
  var v = document.querySelector('.fv__media');
  if (!v) return;
  v.muted = true;

  function pickSrc() {
    var lg = v.getAttribute('data-src-lg');
    var sm = v.getAttribute('data-src-sm');
    return (window.innerWidth >= 768 && lg) ? lg : (sm || lg);
  }

  function loadSrc() {
    if (v.src || v.currentSrc) return true;
    var src = pickSrc();
    if (!src) return false;
    v.src = src;
    v.load();
    return true;
  }

  var gestureAttached = false;

  function tryPlay() {
    if (!v.paused) return;
    if (!loadSrc()) return;
    v.muted = true;
    /* preload="none" なので、src を入れた直後は readyState=0＝データが無い。
       この状態の play() はほぼ確実に弾かれるため、先に復帰経路を張っておく。
       旧実装は「弾かれてから」張っていたが、そちらの経路が once で1回きりだった（下記） */
    attachGestureFallback();
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  /* 2026-08-08（Tomoya「Safari で FV の動画が再生されない」）:
     旧実装は復帰の入り口が **{ once: true } の touchstart / click の2本だけ**だった。

     ところがこの video は preload="none" で src も後入れなので、
     **最初の操作の時点ではまだ1バイトも届いていないことがある**。
     その状態の play() は「データが無い」で普通に弾かれ、
     しかし once のリスナーは**もう外れている**。つまり
     **1回失敗したら二度と再生されない**。
     iOS の低電力モードで自動再生が止められている端末では、
     この1回が必ず失敗するので**確実にポスター静止画のまま**になっていた。

     → 入り口を once にしない。**実際に再生が始まった（playing）ときだけ外す。**
       あわせて「データが届いた瞬間（loadeddata / canplay）」も再試行の入り口に足す。
       ここが本命で、ユーザーの操作を待たずに復帰できる経路。 */
  function attachGestureFallback() {
    if (gestureAttached) return;
    gestureAttached = true;

    function resume() {
      if (!v.paused) return;
      v.muted = true;
      if (!loadSrc()) return;
      if (v.readyState === 0) v.load(); // iOS: force load if not started
      v.play().catch(function(){});
    }
    function detach() {
      document.removeEventListener('touchstart', resume);
      document.removeEventListener('click', resume);
      document.removeEventListener('scroll', resume);
      v.removeEventListener('loadeddata', resume);
      v.removeEventListener('canplay', resume);
    }

    // 成功したときだけ入り口を閉じる
    v.addEventListener('playing', detach, { once: true });

    // touchstart は touchend より先に飛ぶ（iOS Safari で取りこぼしにくい）
    document.addEventListener('touchstart', resume, { passive: true });
    document.addEventListener('click',      resume);
    // スクロールもユーザー操作として扱われる。何も押さない人でも復帰できる
    document.addEventListener('scroll',     resume, { passive: true });
    // データが届いた時点での再試行。操作を待たずに復帰する本命の経路
    v.addEventListener('loadeddata', resume);
    v.addEventListener('canplay',    resume);
  }

  // 動画を取りに行かない環境。ポスターのままにする
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  if (stillReduceMotion || saveData) {
    // 音を鳴らす対象が無いのでミュート切替も出さない
    var mb = document.getElementById('fvMute');
    if (mb) mb.style.display = 'none';
    return;
  }

  function start() {
    // 500ms: 初期描画の直後を避ける / 2500ms: 低速回線の保険
    setTimeout(tryPlay, 500);
    setTimeout(tryPlay, 2500);
  }
  function afterLoad() {
    if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 200);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
})();

/* FV video: seamless loop — toggle .fv--looping on existing element */
(function() {
  const vid = document.querySelector('.fv__media');
  const fv  = document.getElementById('hero');
  if (!vid || !fv) return;
  vid.removeAttribute('loop');

  const FADEOUT = 700;
  const FADEIN  = 500;

  let fading = false;

  vid.addEventListener('timeupdate', () => {
    if (!vid.duration || fading) return;
    const remaining = (vid.duration - vid.currentTime) * 1000;
    if (remaining > FADEOUT) return;
    fading = true;
    fv.classList.add('fv--looping');
  });

  vid.addEventListener('ended', () => {
    vid.currentTime = 0;
    vid.play().catch(() => {});
    fv.classList.remove('fv--looping');
    setTimeout(() => {
      fading = false;
    }, FADEIN + 100);
  });
})();



/* Video fade-in only after first frame is painted (avoids iOS Safari square flash) */
(function() {
  const v = document.querySelector('.fv__bg--video');
  if (!v) return;
  function reveal() { v.classList.add('is-playing'); }
  v.addEventListener('playing', reveal, { once: true });
  v.addEventListener('loadeddata', () => { if (v.readyState >= 3) reveal(); }, { once: true });
  if (v.readyState >= 3) reveal();
  setTimeout(reveal, 3000); // safety net
})();




/* FV mute toggle */
(function() {
  const btn = document.getElementById('fvMute');
  if (!btn) return;
  const iconOff = btn.querySelector('.fv__mute-off');
  const iconOn  = btn.querySelector('.fv__mute-on');
  function allVids() { return document.querySelectorAll('.fv__media'); }
  btn.addEventListener('click', () => {
    const nowMuted = [...allVids()][0]?.muted ?? true;
    const next = !nowMuted;
    allVids().forEach(v => { v.muted = next; });
    iconOff.style.display = next ? '' : 'none';
    iconOn.style.display  = next ? 'none' : '';
    btn.setAttribute('aria-label', next ? '音声をオンにする' : '音声をオフにする');
  });
})();

/* Product gallery: thumbnail/dot click + スワイプ で主画像を切り替える
   2026-08-08（Tomoya「商品画像が複数枚あるときに、画像をカルーセルできない」）:
   切り替え自体は前から動いていたが、**モバイルでは操作する手段が実質無かった**。
     ・.product__thumbs は max-width:768px で display:none（＝サムネイルが無い）
     ・残るドットは 5px 四方。Apple HIG 44px / WCAG 24px のどちらにも遠く、指が乗らない
     ・写真そのものを左右にスワイプする、という一番自然な操作が実装されていなかった
   → ①写真のスワイプ ②ドットのタップ領域拡大（CSS 側 ::before）③ドットのキーボード操作
      の3つを足す。Liquid のマークアップは変えない。 */
(function() {
  const main = document.querySelector('.product__img-main img');
  const stage = document.querySelector('.product__img-main');
  const thumbs = document.querySelectorAll('.product__thumb');
  const dots = document.querySelectorAll('.product__dot');
  if (!main || thumbs.length === 0) return;

  let cur = 0;

  function switchTo(idx) {
    // 端で止めず巻き戻す（枚数が2〜3枚なので、行き止まりを作るより回るほうが迷わない）
    const n = thumbs.length;
    idx = ((idx % n) + n) % n;
    const thumbImg = thumbs[idx]?.querySelector('img');
    if (!thumbImg) return;
    const url = thumbImg.src.replace(/width=\d+/, 'width=800');
    // 主画像は srcset を持つ（main-product.liquid）。src だけ替えても srcset が優先されて写真が変わらない
    if (main.hasAttribute('srcset')) {
      main.srcset = [400, 600, 800, 1100].map(w => thumbImg.src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w').join(', ');
    }
    main.src = url;
    main.alt = thumbImg.alt;
    cur = idx;
    thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
    dots.forEach((d, i) => {
      const on = i === idx;
      d.classList.toggle('active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  /* 2026-10-07: 切り替えに一瞬のラグがあった（Tomoya 指摘）。
     switchTo は主画像の src/srcset を width=800 の URL に差し替えるが、
     その解像度は**まだ一度も読み込まれていない**（サムネイルは width=160）。
     クリックしてから CDN へ取りに行くので、初回だけ空白〜遅延になる。
     → 主画像の表示後、アイドル時間に裏で温めておく。2枚目以降は即時に入れ替わる。
     fetchPriority='low' で初回表示（LCP）の帯域を奪わない。 */
  function warmCache() {
    thumbs.forEach((t, i) => {
      if (i === cur) return;
      const ti = t.querySelector('img');
      if (!ti) return;
      [800, 1100].forEach((w) => {
        const im = new Image();
        if ('fetchPriority' in im) im.fetchPriority = 'low';
        im.src = ti.src.replace(/width=\d+/, 'width=' + w);
      });
    });
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(warmCache, { timeout: 3000 });
  } else {
    window.addEventListener('load', () => setTimeout(warmCache, 600), { once: true });
  }

  thumbs.forEach((t, i) => t.addEventListener('click', () => switchTo(i)));

  /* 2026-09-03: バリアント選択から主画像を切り替えるための口。
     位置(index)ではなく **サムネイルの src 文字列の完全一致** で引き当てる。
     Liquid 側が `image_url: width: 160` で出す文字列と、
     .variant-btn の data-image-src が同じ式なので必ず一致する。
     🚫 product.media の position で引かないこと（画像以外のメディアが1つでも
        混ざると product.images と番号がズレる）。
     見つからなければ false を返して何もしない（画像未割り当ての商品で無害）。 */
  window.stillGallery = {
    showBySrc(src) {
      if (!src) return false;
      for (let i = 0; i < thumbs.length; i++) {
        const im = thumbs[i].querySelector('img');
        if (im && im.getAttribute('src') === src) { switchTo(i); return true; }
      }
      return false;
    }
  };

  dots.forEach((d, i) => {
    // <span> のままなのでフォーカスも読み上げも効かない。JS 側で補う
    d.setAttribute('role', 'button');
    d.setAttribute('tabindex', '0');
    d.setAttribute('aria-label', (i + 1) + '枚目の写真を表示');
    d.addEventListener('click', () => switchTo(i));
    d.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); switchTo(i); }
    });
  });

  /* 写真のスワイプ。縦スクロールを邪魔しないよう、
     横の移動量が縦より大きいときだけジェスチャーとして扱う */
  if (stage && thumbs.length > 1) {
    let sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { tracking = false; return; }
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      switchTo(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
})();

/* Product variant + quantity */
(function() {
  const qtyNum   = document.getElementById('qtyNum');
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus  = document.getElementById('qtyPlus');
  if (!qtyNum) return;

  let qty = 1;
  const MAX = 20;

  function activeBase() {
    // 価格は Liquid の cents 値（JPY は 円 × 100）
    const active = document.querySelector('.variant-btn.active');
    if (active) return parseInt(active.dataset.priceBase, 10) || 0;
    // バリアントなし商品: 価格表示要素の data-price-base にフォールバック
    const fallback = document.querySelector('.product-price[data-price-base]');
    return fallback ? parseInt(fallback.dataset.priceBase, 10) || 0 : 0;
  }

  function fmt(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function updatePrice() {
    const base = activeBase();
    if (!base) return; // 価格情報が取れない場合はサーバーレンダー値を保持
    // 主表示は常に単価。数量を掛けた総額に差し替えると価格の基準が動いて比較しづらくなるため、
    // 総額は数量2以上のときだけ小計として併記する。
    document.querySelectorAll('.product-price').forEach(el => el.textContent = fmt(base));
    const sub = document.getElementById('productSubtotal');
    if (sub) {
      if (qty > 1) {
        sub.textContent = fmt(base) + ' × ' + qty + '\u3000小計 ' + fmt(base * qty);
        sub.hidden = false;
      } else {
        sub.hidden = true;
      }
    }
  }

  function setQty(n) {
    qty = Math.max(1, Math.min(MAX, n));
    qtyNum.textContent = qty;
    qtyMinus.disabled = qty <= 1;
    qtyPlus.disabled  = qty >= MAX;
    updatePrice();
    const cartQtyInput = document.getElementById('cartQty');
    if (cartQtyInput) cartQtyInput.value = qty;
  }


  qtyMinus.addEventListener('click', () => setQty(qty - 1));
  qtyPlus.addEventListener('click',  () => setQty(qty + 1));

  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.variants').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      updatePrice();
      const variantInput = document.getElementById('variantId');
      if (variantInput && btn.dataset.variantId) variantInput.value = btn.dataset.variantId;
      /* 2026-09-03: バリアントに画像が割り当てられていれば主画像も切り替える。
         Dawn と同じ「一覧は全部出したまま、選択中の1枚へジャンプする」挙動。 */
      if (window.stillGallery) window.stillGallery.showBySrc(btn.dataset.imageSrc);
    });
  });

  updatePrice();

  /* Sticky CTA: show only when main add-button is out of viewport */
  const mainBtn   = document.querySelector('.product__add');
  const stickyBar = document.getElementById('productSticky');
  if (mainBtn && stickyBar) {
    const obs = new IntersectionObserver(([e]) => {
      stickyBar.style.transform   = e.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      stickyBar.style.pointerEvents = e.isIntersecting ? 'none' : 'auto';
    }, { threshold: 0 });
    obs.observe(mainBtn);
  }
})();

/* Contact form: 二重送信ガード。
   素の POST 送信はそのまま通し、送信開始後（次タスク）にボタンだけ無効化する。
   JS 無効環境ではガードなしで通常送信（挙動劣化なし）。 */
(function() {
  const form = document.getElementById('ContactForm');
  if (!form) return;
  const btn = form.querySelector('[type="submit"]');
  if (!btn) return;
  form.addEventListener('submit', function() {
    // 同期で disable すると送信自体が止まるブラウザがあるため次タスクで無効化
    setTimeout(function() { btn.disabled = true; }, 0);
    // ナビゲーション中断（オフライン等）時の救済
    setTimeout(function() { btn.disabled = false; }, 10000);
  });
  // bfcache 復帰時に disabled のまま固まるのを防ぐ
  window.addEventListener('pageshow', function() { btn.disabled = false; });
})();

/* FAQ accordion — width-locked, no native <details> quirks */
(function() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.faq__q');
    if (!btn) return;
    e.preventDefault();
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    const answer = btn.nextElementSibling;
    if (answer && answer.classList.contains('faq__a')) {
      answer.classList.toggle('is-open');
    }
  });
})();
